/* Local SEO Command Center — Dashboard v2 (Dynamic) */

/* ── CONFIG ── */
const SITE_BASE = 'https://nlwebdesign.com';
const DASHBOARD_URL = 'https://local-seo-cc.pages.dev';
const HEALTH_CHECK_INTERVAL = 60000; // 60s
const STATUS_ORDER = ['planned', 'building', 'qa', 'done', 'deployed'];
const STATUS_LABELS = { planned: 'Planned', building: 'Building', qa: 'In QA', done: 'Completed', deployed: 'Deployed' };
const STATUS_COLORS = { planned: 'var(--blue)', building: 'var(--amber)', qa: 'var(--purple)', done: 'var(--green)', deployed: 'var(--teal)' };
const TYPE_COLORS = { service: 'var(--blue)', location: 'var(--green)', industry: 'var(--amber)', comparison: 'var(--red)', faq: 'var(--purple)' };

/* ── DATA MODEL ── */
let pages = loadData();
let activities = loadActivities();
let healthData = {};
let healthTimer = null;
let autoRefresh = true;

function seedData() {
  return [
    { id: '1', title: 'Web Design in Redding, CA', slug: '/web-design-redding-ca', type: 'service', status: 'deployed', priority: 1, keywords: ['redding web design','website design redding','web designer redding ca'], location: 'Redding', county: 'Shasta', intent: 'commercial', notes: 'Primary service page. Rich 2000+ word rewrite with AI-generated Sundial Bridge hero image, with 3-skill SEO combo. Definition block, 6 features, 6 process steps, 6 FAQs with schema. Deployed 2026-05-14.', createdAt: '2026-05-12', deployedAt: '2026-05-14' },
    { id: '2', title: 'Web Design in Shasta County', slug: '/web-design-shasta-county', type: 'location', status: 'deployed', priority: 1, keywords: ['shasta county web design','website design shasta county','web designer shasta county ca'], location: 'Shasta County', county: 'Shasta', intent: 'commercial', notes: 'County-level location page. Rich rewrite with tourism/outdoors angle. AI-generated Mount Lassen hero image, 6 features, 6 process, 6 FAQs. Deployed 2026-05-14.', createdAt: '2026-05-12', deployedAt: '2026-05-14' },
    { id: '3', title: 'Website Redesign Services in Redding', slug: '/website-redesign-redding', type: 'service', status: 'deployed', priority: 1, keywords: ['website redesign redding','website refresh redding ca','update website redding'], location: 'Redding', county: 'Shasta', intent: 'commercial', notes: 'Targets businesses with outdated sites. Rich rewrite with redesign-specific audit/migration angle. AI-generated before-after hero image, 6 process, 6 FAQs. Deployed 2026-05-14.', createdAt: '2026-05-12', deployedAt: '2026-05-14' },
    { id: '4', title: 'SEO Services in Redding, CA', slug: '/seo-services-redding', type: 'service', status: 'deployed', priority: 1, keywords: ['redding seo','seo company redding','local seo redding ca','seo services shasta county'], location: 'Redding', county: 'Shasta', intent: 'commercial', notes: 'High-intent service page. Rich rewrite with 6 service pillars. AI-generated Google ranking hero image,, Moz/BrightLocal citations. 6 process, 6 FAQs. Deployed 2026-05-14.', createdAt: '2026-05-12', deployedAt: '2026-05-14' },
    { id: '5', title: 'Small Business Websites in Redding', slug: '/small-business-websites-redding', type: 'service', status: 'deployed', priority: 2, keywords: ['small business website redding','website for small business redding ca','affordable website design redding'], location: 'Redding', county: 'Shasta', intent: 'commercial', notes: 'Price-sensitive audience. Rich rewrite with $2,500 starting price. AI-generated Main Street hero image,, 6 business types, SBA growth stat. 6 FAQs. Deployed 2026-05-14.', createdAt: '2026-05-12', deployedAt: '2026-05-14' },
    { id: '6', title: 'Digital Marketing in Shasta County', slug: '/digital-marketing-shasta-county', type: 'service', status: 'deployed', priority: 2, keywords: ['digital marketing redding','digital marketing shasta county','online marketing redding ca'], location: 'Shasta County', county: 'Shasta', intent: 'commercial', notes: 'Broader service umbrella. Rich rewrite with 6 industries. AI-generated digital marketing workspace hero image,, 6 services, 6 process steps. Deployed 2026-05-14.', createdAt: '2026-05-12', deployedAt: '2026-05-14' },
    { id: '7', title: 'Contractor Website Design in Redding, CA', slug: '/contractor-website-design-redding', type: 'industry', status: 'deployed', priority: 2, keywords: ['contractor website design redding','construction website redding ca','contractor web design shasta county'], location: 'Redding', county: 'Shasta', intent: 'commercial', notes: 'Industry-specific page. Rich rewrite with 6 trades. AI-generated contractor hero image,, emergency callout, license/insurance trust signals. 6 features, 6 FAQs. Deployed 2026-05-14.', createdAt: '2026-05-12', deployedAt: '2026-05-14' },
    { id: '8', title: 'How Much Does a Website Cost in Redding, CA?', slug: '/how-much-does-a-website-cost-redding', type: 'faq', status: 'deployed', priority: 3, keywords: ['how much does a website cost redding','website cost redding ca','web design pricing redding'], location: 'Redding', county: 'Shasta', intent: 'informational', notes: 'FAQ/resource page. Rich rewrite with 3 pricing tiers. AI-generated pricing calculator hero image,, 6 cost factors, annual costs table. AI-generated hero image (pricing calculator concept). 6 FAQs with pricing details. Deployed 2026-05-14.', createdAt: '2026-05-12', deployedAt: '2026-05-14' },
  ];
}

function loadData() {
  try {
    const raw = localStorage.getItem('seo_pages_v2');
    if (raw) return JSON.parse(raw);
  } catch(e) {}
  // Migrate from v1 or seed
  const v1 = localStorage.getItem('seo_pages');
  if (v1) {
    try {
      const old = JSON.parse(v1);
      // Upgrade: add deployedAt where status is deployed, update slug mismatches
      return old.map(p => ({ ...p, deployedAt: p.status === 'deployed' ? '2026-05-14' : undefined }));
    } catch(e) {}
  }
  return seedData();
}

function saveData() {
  localStorage.setItem('seo_pages_v2', JSON.stringify(pages));
  localStorage.setItem('seo_pages', JSON.stringify(pages)); // keep v1 in sync
}

function loadActivities() {
  try {
    const raw = localStorage.getItem('seo_activities_v2');
    if (raw) return JSON.parse(raw);
  } catch(e) {}
  return [
    { text: 'All 8 pages rewritten with rich content (1500-2500 words each)', color: 'green', time: '2026-05-14' },
    { text: 'All 8 pages deployed & live', color: 'green', time: '2026-05-14' },
    { text: 'Dashboard v2 launched with live health checks', color: 'blue', time: '2026-05-14' },
    { text: 'WordPress redirect fix (commit 3c40e7a)', color: 'green', time: '2026-05-14' },
    { text: 'SEO pages verified on nlwebdesign.com', color: 'green', time: '2026-05-14' },
    { text: 'Cloudflare Pages connected (local-seo-cc)', color: 'blue', time: '2026-05-14' },
    { text: '10 initial page opportunities seeded', color: 'blue', time: '2026-05-12' },
    { text: 'Dashboard initialized', color: 'green', time: '2026-05-12' },
  ];
}

function saveActivities() { localStorage.setItem('seo_activities_v2', JSON.stringify(activities)); }

function addActivity(text, color = 'blue') {
  const now = new Date().toISOString().split('T')[0];
  activities.unshift({ text, color, time: now });
  if (activities.length > 30) activities = activities.slice(0, 30);
  saveActivities();
  renderActivities();
}

/* ── HEALTH CHECK ── */
async function checkPageHealth(slug) {
  const url = `${SITE_BASE}${slug}`;
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    const res = await fetch(url, { method: 'HEAD', mode: 'no-cors', signal: controller.signal });
    clearTimeout(timeout);
    // no-cors returns opaque response, status 0 but no error means reachable
    const code = res.status === 0 ? 200 : res.status;
    return { url, slug, code, ok: code >= 200 && code < 400, ts: Date.now() };
  } catch (e) {
    // Try a simple connectivity check via Image load
    return new Promise((resolve) => {
      const img = new Image();
      const timeout = setTimeout(() => {
        resolve({ url, slug, code: 0, ok: false, ts: Date.now(), error: 'timeout' });
      }, 6000);
      img.onload = () => { clearTimeout(timeout); resolve({ url, slug, code: 200, ok: true, ts: Date.now() }); };
      img.onerror = () => { clearTimeout(timeout); resolve({ url, slug, code: 500, ok: false, ts: Date.now(), error: 'load_failed' }); };
      img.src = url + '?_t=' + Date.now();
    });
  }
}

async function runFullHealthCheck() {
  const deployed = pages.filter(p => p.status === 'deployed');
  if (!deployed.length) return;

  addStreamItem(`Checking ${deployed.length} deployed pages...`, 'info');

  const results = await Promise.all(deployed.map(p => checkPageHealth(p.slug)));
  results.forEach(r => { healthData[r.slug] = r; });

  renderHealthGrid();
  renderHealthDetail();
  updateHealthBadge();
  updateSidebarStats();
  updateRefreshTime();

  const allOk = results.every(r => r.ok);
  if (allOk) {
    addStreamItem(`✓ All ${results.length} pages healthy`, 'success');
    addActivity(`Health check: all ${results.length} deployed pages OK`, 'green');
  } else {
    const failCount = results.filter(r => !r.ok).length;
    addStreamItem(`✗ ${failCount} page(s) failing`, 'fail');
    addActivity(`Health check: ${failCount} page(s) failing`, 'red');
  }
  renderMetrics();
}

function updateRefreshTime() {
  const el = document.getElementById('last-refresh');
  if (el) {
    const now = new Date();
    el.textContent = `Updated ${now.toLocaleTimeString()}`;
  }
  const indicator = document.getElementById('live-indicator');
  if (indicator) indicator.classList.add('active');
}

function updateHealthBadge() {
  const badge = document.getElementById('site-health-badge');
  const summary = document.getElementById('health-summary');
  const deployed = pages.filter(p => p.status === 'deployed');
  if (!deployed.length) {
    if (badge) badge.textContent = 'no pages';
    if (summary) summary.textContent = '—';
    return;
  }
  const checked = deployed.filter(p => healthData[p.slug]);
  const ok = checked.filter(p => healthData[p.slug]?.ok);
  if (!checked.length) {
    if (badge) badge.textContent = 'checking...';
    if (summary) summary.textContent = 'checking...';
  } else if (ok.length === checked.length) {
    if (badge) { badge.textContent = `${ok.length}/${checked.length} healthy`; badge.style.background = 'var(--green-bg)'; badge.style.color = 'var(--green)'; }
    if (summary) summary.textContent = `${ok.length}/${checked.length} pages healthy`;
  } else {
    const failCount = checked.length - ok.length;
    if (badge) { badge.textContent = `${failCount} issue(s)`; badge.style.background = 'var(--red-bg)'; badge.style.color = 'var(--red)'; }
    if (summary) summary.textContent = `${failCount} page(s) failing`;
  }
}

/* ── STREAM ── */
function addStreamItem(text, type = 'info') {
  const el = document.getElementById('live-stream');
  if (!el) return;
  const item = document.createElement('div');
  item.className = `stream-item ${type}`;
  item.textContent = text;
  el.appendChild(item);
  setTimeout(() => item.remove(), 3500);
}

/* ── UI CONTROLLER ── */
const UI = {
  currentTab: 'overview',

  init() {
    renderMetrics();
    renderActivities();
    renderOpportunities();
    renderPackages();
    renderPipeline();
    renderHealthGrid();
    renderHealthDetail();
    renderQAPageSelect();
    updateHealthBadge();
    updateSidebarStats();
    updateRefreshTime();
    this.setupForms();
    // Initial health check
    runFullHealthCheck();
    // Auto-refresh
    this.startAutoRefresh();
  },

  switchTab(tab) {
    this.currentTab = tab;
    document.querySelectorAll('.nav-item').forEach(el => el.classList.remove('active'));
    document.querySelector(`[data-tab="${tab}"]`)?.classList.add('active');
    document.querySelectorAll('.tab').forEach(el => el.classList.remove('active'));
    document.getElementById(`tab-${tab}`)?.classList.add('active');
  },

  filterOpportunities() { renderOpportunities(); },

  render() {
    renderMetrics();
    renderActivities();
    renderOpportunities();
    renderPackages();
    renderPipeline();
    renderHealthGrid();
    renderHealthDetail();
    renderQAPageSelect();
    updateHealthBadge();
    updateSidebarStats();
  },

  refreshHealth() {
    addStreamItem('Running health check...', 'info');
    runFullHealthCheck();
  },

  startAutoRefresh() {
    if (healthTimer) clearInterval(healthTimer);
    const toggle = document.getElementById('auto-refresh-toggle');
    autoRefresh = toggle ? toggle.checked : true;
    if (autoRefresh) {
      healthTimer = setInterval(() => {
        if (autoRefresh) runFullHealthCheck();
      }, HEALTH_CHECK_INTERVAL);
    }
    toggle?.addEventListener('change', () => {
      autoRefresh = toggle.checked;
      if (autoRefresh) {
        this.startAutoRefresh();
      } else {
        clearInterval(healthTimer);
      }
    });
  },

  showNewPage() {
    const content = `
      <h3 style="margin-bottom:16px;font-size:16px;font-weight:600;">New Page Opportunity</h3>
      <form id="new-page-form" class="form-grid">
        <div class="form-group"><label>Title</label><input id="np-title" class="input-field" placeholder="e.g., Web Design in Redding"></div>
        <div class="form-group"><label>Slug</label><input id="np-slug" class="input-field" placeholder="/service-location"></div>
        <div class="form-group"><label>Type</label><select id="np-type" class="input-select"><option value="service">Service</option><option value="location">Location</option><option value="industry">Industry</option><option value="comparison">Comparison</option><option value="faq">FAQ / Resource</option></select></div>
        <div class="form-group"><label>Priority</label><select id="np-priority" class="input-select"><option value="1">P1 — Must Have</option><option value="2">P2 — High</option><option value="3">P3 — Medium</option><option value="4">P4 — Nice</option></select></div>
        <div class="form-group"><label>Target City</label><input id="np-location" class="input-field" placeholder="Redding"></div>
        <div class="form-group"><label>County</label><input id="np-county" class="input-field" placeholder="Shasta"></div>
        <div class="form-group form-group-full"><label>Keywords (comma-separated)</label><input id="np-keywords" class="input-field" placeholder="redding web design, website designer redding"></div>
        <div class="form-group form-group-full"><label>Notes</label><textarea id="np-notes" class="input-textarea" rows="3"></textarea></div>
        <div class="form-group form-group-full"><button type="submit" class="btn btn-primary">Add Opportunity</button></div>
      </form>
    `;
    UI.showModal(content);
    setTimeout(() => {
      document.getElementById('new-page-form')?.addEventListener('submit', (e) => {
        e.preventDefault();
        const page = {
          id: String(Date.now()),
          title: document.getElementById('np-title').value,
          slug: document.getElementById('np-slug').value,
          type: document.getElementById('np-type').value,
          priority: parseInt(document.getElementById('np-priority').value),
          location: document.getElementById('np-location').value,
          county: document.getElementById('np-county').value,
          keywords: document.getElementById('np-keywords').value.split(',').map(s => s.trim()).filter(Boolean),
          notes: document.getElementById('np-notes').value,
          status: 'planned',
          createdAt: new Date().toISOString().split('T')[0],
        };
        pages.unshift(page);
        saveData();
        addActivity(`Added page opportunity: ${page.title}`, 'green');
        UI.hideModal();
        UI.switchTab('opportunities');
        UI.render();
      });
    }, 50);
  },

  showPackage(id) {
    const page = pages.find(p => p.id === id);
    if (!page) return;
    const schema = generateSchema(page);
    const meta = generateMeta(page);
    const healthInfo = page.status === 'deployed' ? healthData[page.slug] : null;
    const healthRow = healthInfo ? `
      <div style="display:flex;gap:16px;align-items:center;padding:8px 12px;background:var(--bg-input);border-radius:var(--radius-sm);">
        <span style="color:${healthInfo.ok ? 'var(--green)' : 'var(--red)'};font-weight:700;">${healthInfo.ok ? '✓ HEALTHY' : '✗ FAILING'}</span>
        <span style="font-family:monospace;font-size:12px;color:var(--text-muted);">${healthInfo.url}</span>
        <span style="font-size:11px;color:var(--text-muted);">${healthInfo.code ? `HTTP ${healthInfo.code}` : 'N/A'}</span>
      </div>
    ` : '';

    const deployedUrl = page.status === 'deployed' ? `${SITE_BASE}${page.slug}` : '';
    const deployedLink = deployedUrl ? `<a href="${deployedUrl}" target="_blank" style="color:var(--primary-hover);font-size:12px;">Open live page ↗</a>` : '';

    const statusIdx = STATUS_ORDER.indexOf(page.status);
    const canAdvance = statusIdx < STATUS_ORDER.length - 1;
    const canRegress = statusIdx > 0;

    const advanceBtn = canAdvance ? `<button class="btn btn-sm" style="background:var(--green-bg);border-color:var(--green);color:var(--green);" onclick="advanceStatus('${page.id}', 1)">→ ${STATUS_LABELS[STATUS_ORDER[statusIdx + 1]]}</button>` : '';
    const regressBtn = canRegress ? `<button class="btn btn-sm" style="background:var(--amber-bg);border-color:var(--amber);color:var(--amber);" onclick="advanceStatus('${page.id}', -1)">← ${STATUS_LABELS[STATUS_ORDER[statusIdx - 1]]}</button>` : '';

    const content = `
      <div class="package-detail">
        <div class="package-section">
          <div style="display:flex;justify-content:space-between;align-items:flex-start;">
            <h4>${page.title}</h4>
            ${deployedLink}
          </div>
          <p style="margin-top:4px;"><code style="background:var(--bg-input);padding:2px 6px;border-radius:4px;font-size:12px;">${page.slug}</code> &nbsp;|&nbsp; <span style="color:${STATUS_COLORS[page.status]};font-weight:600;">● ${STATUS_LABELS[page.status]}</span> &nbsp;|&nbsp; Priority P${page.priority}</p>
          ${healthRow}
        </div>
        <div class="package-section">
          <h4>Target Keywords</h4>
          <p>${page.keywords.map(k => `<span class="tag" style="background:${TYPE_COLORS[page.type] || 'var(--primary)'}22;color:${TYPE_COLORS[page.type] || 'var(--primary)'}">${k}</span>`).join(' ')}</p>
        </div>
        <div class="package-section">
          <h4>SEO Title & Meta</h4>
          <pre>&lt;title&gt;${meta.title}&lt;/title&gt;\n&lt;meta name="description" content="${meta.description}"&gt;</pre>
        </div>
        <div class="package-section">
          <h4>Schema (JSON-LD)</h4>
          <pre>${schema}</pre>
        </div>
        <div class="package-section">
          <h4>Notes</h4>
          <p>${page.notes || '—'}</p>
        </div>
        <div class="package-section" style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;">
          ${regressBtn}
          ${advanceBtn}
          <button class="btn btn-danger btn-sm" onclick="deletePage('${page.id}')">🗑 Delete</button>
        </div>
      </div>
    `;
    UI.showModal(content);
  },

  showModal(html) {
    document.getElementById('modal-content').innerHTML = html;
    document.getElementById('modal-overlay').classList.add('show');
  },

  hideModal() {
    document.getElementById('modal-overlay').classList.remove('show');
  },

  toast(msg, type = 'info') {
    const el = document.createElement('div');
    el.className = `toast toast-${type}`;
    el.textContent = msg;
    document.getElementById('toast-container').appendChild(el);
    setTimeout(() => el.remove(), 3000);
  },

  setupForms() {
    document.getElementById('research-form')?.addEventListener('submit', (e) => {
      e.preventDefault();
      const service = document.getElementById('res-service').value;
      const city = document.getElementById('res-city').value;
      const county = document.getElementById('res-county').value;
      const intent = document.getElementById('res-intent').value;
      const notes = document.getElementById('res-notes').value;
      if (!service || !city) { UI.toast('Service and City are required', 'error'); return; }
      const page = {
        id: String(Date.now()),
        title: `${service} in ${city}${county ? ', ' + county : ''}`,
        slug: `/${service.toLowerCase().replace(/\s+/g, '-')}-${city.toLowerCase().replace(/\s+/g, '-')}`,
        type: 'service', status: 'planned',
        priority: intent === 'commercial' ? 1 : 2,
        keywords: [`${service} ${city}`, `${service} ${city} ca`],
        location: city, county: county || '', intent,
        notes: notes || `Researched ${service} in ${city}. Search intent: ${intent}.`,
        createdAt: new Date().toISOString().split('T')[0],
      };
      pages.unshift(page);
      saveData();
      addActivity(`Researched & added: ${page.title}`, 'green');
      UI.toast('Page opportunity added!', 'success');
      e.target.reset();
      UI.render();
    });

    document.getElementById('qa-form')?.addEventListener('submit', (e) => {
      e.preventDefault();
      const pageId = document.getElementById('qa-page').value;
      if (!pageId) { UI.toast('Please select a page', 'error'); return; }
      const page = pages.find(p => p.id === pageId);
      if (!page) return;
      const checks = {
        content: document.getElementById('qa-content').value,
        cannibal: document.getElementById('qa-cannibal').value,
        nap: document.getElementById('qa-nap').value,
        schema: document.getElementById('qa-schema').value,
        meta: document.getElementById('qa-meta').value,
        links: document.getElementById('qa-links').value,
        cta: document.getElementById('qa-cta').value,
        local: document.getElementById('qa-local').value,
      };
      const notes = document.getElementById('qa-notes').value;
      const allPass = Object.values(checks).every(v => v && !v.includes('fail') && !v.includes('none') && !v.includes('missing') && !v.includes('weak'));
      if (allPass) {
        page.status = 'done';
        addActivity(`QA passed: ${page.title}`, 'green');
        UI.toast(`QA passed — ${page.title} marked complete`, 'success');
      } else {
        page.qa = { checks, notes, date: new Date().toISOString().split('T')[0] };
        addActivity(`QA flagged: ${page.title}`, 'amber');
        UI.toast(`QA saved — some checks need attention`, 'error');
      }
      saveData();
      UI.render();
      e.target.reset();
    });
  },
};

/* ── RENDERING ── */
function renderMetrics() {
  const byStatus = { planned: 0, building: 0, qa: 0, done: 0, deployed: 0 };
  pages.forEach(p => { if (byStatus[p.status] !== undefined) byStatus[p.status]++; });
  const total = pages.length;
  document.getElementById('metric-total').textContent = total;
  document.getElementById('metric-planned').textContent = byStatus.planned;
  document.getElementById('metric-building').textContent = byStatus.building;
  document.getElementById('metric-qa').textContent = byStatus.qa;
  document.getElementById('metric-done').textContent = byStatus.done;
  document.getElementById('metric-deployed').textContent = byStatus.deployed;
  // Update ring
  const ringTotal = document.querySelector('#ring-total circle:last-child');
  if (ringTotal) {
    const pct = total > 0 ? (byStatus.deployed / total) * 100 : 0;
    ringTotal.setAttribute('stroke-dasharray', `${pct} ${100 - pct}`);
  }
}

function renderActivities() {
  const el = document.getElementById('recent-activity');
  if (!el) return;
  el.innerHTML = activities.slice(0, 10).map(a => `
    <div class="activity-item">
      <span class="activity-dot ${a.color}"></span>
      <span class="activity-text">${a.text}</span>
      <span class="activity-time">${a.time}</span>
    </div>
  `).join('');
}

function renderOpportunities() {
  const listEl = document.getElementById('opportunity-list');
  if (!listEl) return;
  const search = (document.getElementById('search-input')?.value || '').toLowerCase();
  const statusF = document.getElementById('filter-status')?.value || '';
  const typeF = document.getElementById('filter-type')?.value || '';
  const priorityF = document.getElementById('filter-priority')?.value || '';

  let filtered = pages.filter(p => {
    const matchesSearch = !search || [p.title, p.slug, p.keywords.join(' '), p.notes].join(' ').toLowerCase().includes(search);
    const matchesStatus = !statusF || p.status === statusF;
    const matchesType = !typeF || p.type === typeF;
    const matchesPriority = !priorityF || String(p.priority) === priorityF;
    return matchesSearch && matchesStatus && matchesType && matchesPriority;
  });
  filtered.sort((a, b) => (a.priority || 4) - (b.priority || 4));

  listEl.innerHTML = filtered.map(p => `
    <div class="opportunity-card" onclick="UI.showPackage('${p.id}')">
      <span class="op-card-status status-dot-${p.status}"></span>
      <div class="op-card-info">
        <div class="op-card-title">${p.title}</div>
        <div class="op-card-slug">${SITE_BASE}${p.slug}</div>
      </div>
      <div class="op-card-tags">
        <span class="tag tag-${p.type}">${p.type}</span>
        <span class="priority priority-p${p.priority}">P${p.priority}</span>
      </div>
      <div class="op-card-meta">
        <span>${p.location}</span>
        <span>·</span>
        <span style="color:${STATUS_COLORS[p.status]}">${STATUS_LABELS[p.status]}</span>
      </div>
    </div>
  `).join('');
}

function renderPackages() {
  const el = document.getElementById('packages-list');
  if (!el) return;
  const withPackage = pages.filter(p => p.status !== 'planned');
  if (!withPackage.length) {
    el.innerHTML = '<p class="text-muted">No page packages yet. Click a page opportunity and advance it to "Building" to begin.</p>';
    return;
  }
  el.innerHTML = withPackage.map(p => `
    <div class="opportunity-card" onclick="UI.showPackage('${p.id}')">
      <span class="op-card-status status-dot-${p.status}"></span>
      <div class="op-card-info">
        <div class="op-card-title">${p.title}</div>
        <div class="op-card-slug">${SITE_BASE}${p.slug}</div>
      </div>
      <div class="op-card-tags">
        <span class="tag tag-${p.type}">${p.type}</span>
        <span class="priority priority-p${p.priority}">P${p.priority}</span>
      </div>
      <div class="op-card-meta">
        <span style="color:${STATUS_COLORS[p.status]}">${STATUS_LABELS[p.status]}</span>
      </div>
    </div>
  `).join('');
}

function renderPipeline() {
  const board = document.getElementById('pipeline-board');
  if (!board) return;

  board.innerHTML = STATUS_ORDER.map(status => {
    const statusPages = pages.filter(p => p.status === status);
    const colClass = `column-${status}`;
    return `
      <div class="pipeline-column ${colClass}">
        <div class="pipeline-column-header">
          <span class="pipeline-column-title">${STATUS_LABELS[status]}</span>
          <span class="pipeline-column-count">${statusPages.length}</span>
        </div>
        <div class="pipeline-column-body">
          ${statusPages.map(p => {
            const idx = STATUS_ORDER.indexOf(status);
            const advBtn = idx < STATUS_ORDER.length - 1 ? `<span class="pipeline-arrow" onclick="advanceStatus('${p.id}', 1); event.stopPropagation();">→ ${STATUS_LABELS[STATUS_ORDER[idx+1]]}</span>` : '';
            const regBtn = idx > 0 ? `<span class="pipeline-arrow" onclick="advanceStatus('${p.id}', -1); event.stopPropagation();">← ${STATUS_LABELS[STATUS_ORDER[idx-1]]}</span>` : '';
            return `
              <div class="pipeline-card" onclick="UI.showPackage('${p.id}')">
                <div class="pipeline-card-title">${p.title}</div>
                <div class="pipeline-card-slug">${p.slug}</div>
                <div class="pipeline-card-tags">
                  <span class="tag tag-${p.type}">${p.type}</span>
                  <span class="priority priority-p${p.priority}">P${p.priority}</span>
                </div>
                <div class="pipeline-card-actions">${regBtn}${advBtn}</div>
              </div>
            `;
          }).join('')}
          ${statusPages.length === 0 ? '<div style="padding:20px;text-align:center;font-size:12px;color:var(--text-muted);">No pages</div>' : ''}
        </div>
      </div>
    `;
  }).join('');
}

function renderHealthGrid() {
  const el = document.getElementById('health-grid');
  if (!el) return;
  const deployed = pages.filter(p => p.status === 'deployed');
  if (!deployed.length) { el.innerHTML = '<p class="text-muted">No deployed pages to check.</p>'; return; }

  el.innerHTML = deployed.map(p => {
    const h = healthData[p.slug];
    const isOk = h?.ok;
    const code = h?.code || '—';
    const codeClass = isOk === undefined ? 'pending' : (isOk ? 'ok' : 'err');
    return `
      <div class="health-tile">
        <div style="display:flex;justify-content:space-between;align-items:center;">
          <span class="health-tile-label">${p.title.length > 28 ? p.title.substring(0, 26) + '…' : p.title}</span>
          <span class="health-tile-code ${codeClass}">${isOk ? '✓' : (isOk === false ? '✗' : '…')} ${code}</span>
        </div>
        <div class="health-tile-url">${p.slug}</div>
        <a class="health-tile-link" href="${SITE_BASE}${p.slug}" target="_blank">Visit page ↗</a>
      </div>
    `;
  }).join('');
}

function renderHealthDetail() {
  const el = document.getElementById('health-detail');
  if (!el) return;
  const deployed = pages.filter(p => p.status === 'deployed');
  if (!deployed.length) { el.innerHTML = '<p class="text-muted">No deployed pages.</p>'; return; }

  el.innerHTML = deployed.map(p => {
    const h = healthData[p.slug];
    const isOk = h?.ok;
    const code = h?.code || '—';
    const codeClass = isOk === undefined ? 'pending' : (isOk ? 'ok' : 'err');
    const ts = h?.ts ? new Date(h.ts).toLocaleTimeString() : '—';
    return `
      <div class="health-detail-card">
        <div class="health-detail-header">
          <div class="health-detail-title">${p.title}</div>
          <span class="health-detail-code ${codeClass}">${isOk === undefined ? '…' : (isOk ? '✓ OK' : '✗ FAIL')}</span>
        </div>
        <div class="health-detail-url">${SITE_BASE}${p.slug}</div>
        <div class="health-detail-meta">
          <span>HTTP ${code}</span>
          <span>·</span>
          <span>Checked ${ts}</span>
        </div>
        <a class="health-detail-link" href="${SITE_BASE}${p.slug}" target="_blank">Open page ↗</a>
      </div>
    `;
  }).join('');
}

function updateSidebarStats() {
  const deployed = pages.filter(p => p.status === 'deployed').length;
  const statsNum = document.querySelector('#sidebar-stat-deployed .stat-num');
  if (statsNum) statsNum.textContent = deployed;
  const healthNum = document.querySelector('#sidebar-stat-health .stat-num');
  const checked = Object.values(healthData);
  const ok = checked.filter(h => h.ok).length;
  if (healthNum) healthNum.textContent = checked.length ? `${ok}/${checked.length}` : '—';
}

function renderQAPageSelect() {
  const sel = document.getElementById('qa-page');
  if (!sel) return;
  sel.innerHTML = '<option value="">— Select a page —</option>' + pages.map(p => `<option value="${p.id}">${p.title} (${STATUS_LABELS[p.status] || p.status})</option>`).join('');
}

/* ── GENERATORS ── */
function generateMeta(page) {
  const city = page.location;
  const service = page.title.split(' in ')[0] || page.title;
  const title = `${service} | Next Level Web Design — ${city}, CA`;
  const desc = `Looking for ${service.toLowerCase()} in ${city}, CA? Next Level Web Design builds high-converting websites for local businesses. Call 530-457-1522.`;
  return { title, description: desc };
}

function generateSchema(page) {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Next Level Web Design",
    "image": "https://nlwebdesign.com/logo.png",
    "url": "https://nlwebdesign.com",
    "telephone": "+15304571522",
    "address": { "@type": "PostalAddress", "addressLocality": "Redding", "addressRegion": "CA", "addressCountry": "US" },
    "areaServed": { "@type": "City", "name": page.location },
    "serviceType": page.keywords[0] || "Web Design"
  }, null, 2);
}

/* ── ACTIONS ── */
function advanceStatus(id, direction) {
  const page = pages.find(p => p.id === id);
  if (!page) return;
  const currentIdx = STATUS_ORDER.indexOf(page.status);
  const newIdx = currentIdx + direction;
  if (newIdx < 0 || newIdx >= STATUS_ORDER.length) return;
  const newStatus = STATUS_ORDER[newIdx];
  page.status = newStatus;
  if (newStatus === 'deployed' && !page.deployedAt) {
    page.deployedAt = new Date().toISOString().split('T')[0];
  }
  saveData();
  addActivity(`Status: ${page.title} → ${STATUS_LABELS[newStatus]}`, newStatus === 'deployed' ? 'green' : 'blue');
  UI.toast(`${page.title} → ${STATUS_LABELS[newStatus]}`, 'success');
  UI.render();
  // If newly deployed, run health check
  if (newStatus === 'deployed') {
    setTimeout(() => runFullHealthCheck(), 500);
  }
}

function updateStatus(id, status) {
  advanceStatus(id, STATUS_ORDER.indexOf(status) - STATUS_ORDER.indexOf(pages.find(p => p.id === id)?.status || 'planned'));
}

function deletePage(id) {
  const page = pages.find(p => p.id === id);
  if (!page) return;
  if (!confirm(`Delete "${page.title}"? This cannot be undone.`)) return;
  pages = pages.filter(p => p.id !== id);
  saveData();
  addActivity(`Deleted page: ${page.title}`, 'red');
  UI.toast('Page deleted', 'info');
  UI.render();
  UI.hideModal();
}

/* ── BOOT ── */
document.addEventListener('DOMContentLoaded', () => UI.init());